import {
  mapState,
  mapMutations
} from 'vuex'
import api from '../service/services.js'
import moment from 'moment'
import swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import 'vue-loading-overlay/dist/vue-loading.min.css'

export default {
  name: 'report',
  data () {
    return {
      datestart: moment(new Date()).format('YYYY-MM-DD'),
      dateend: moment(new Date()).format('YYYY-MM-DD'),
      datemonth: moment(new Date()).format('YYYY-MM'),
      screenHeight: window.innerHeight - 225,
      title: ''
    }
  },
  computed: {
    ...mapState(['user', 'url']),
    ...mapMutations(['checkLogin'])
  },
  methods: {
    showModalDay (id) {
      this.datestart = moment(new Date()).format('YYYY-MM-DD')
      this.dateend = moment(new Date()).format('YYYY-MM-DD')
      if (id === 0) {
        this.title = 'รายงานขายประจำวัน'
      } else {
        this.title = 'รายงาน commission ประจำวัน'
      }
      $('#day').modal('show')
    },
    hideModalDay (id) {
      this.datestart = moment(new Date()).format('YYYY-MM-DD')
      this.dateend = moment(new Date()).format('YYYY-MM-DD')
      $('#day').modal('hide')
    },
    showModalEmailDay (id) {
      this.datestart = moment(new Date()).format('YYYY-MM-DD')
      this.dateend = moment(new Date()).format('YYYY-MM-DD')
      this.title = 'รายงานข้อมูลอีเมล'
      $('#Memail').modal('show')
    },
    hideModalEmailDay (id) {
      this.datestart = moment(new Date()).format('YYYY-MM-DD')
      this.dateend = moment(new Date()).format('YYYY-MM-DD')
      $('#Memail').modal('hide')
    },
    pdfday () {
      let obj = {
        date_start: this.datestart,
        date_end: this.dateend
      }
      if (this.title === 'รายงานขายประจำวัน') {
        api.AXreportday(this.url, obj, result => {
          if (result.status === 1) {
            if (result.data.length > 0) {
              window.open(this.url + '/reports/sale_pdf.php?start=' + moment(this.datestart).format('YYYY-MM-DD') + '&end=' + moment(this.dateend).format('YYYY-MM-DD'), '_blank')
              this.hideModalDay()
            } else {
              swal(
                'Alert REPORT Sale!!',
                'NO data sale!!',
                'error'
              )
              this.hideModalDay()
            }
          } else {
            swal(
              'Alert REPORT Sale!!',
              'NO data in report!!',
              'warning'
            )
            this.hideModalDay()
          }
        }, error => {
          alert(JSON.stringify(error))
          this.hideModalMonth()
        })
      } else {
        api.AXreportcom(this.url, obj, result => {
          if (result.status === 1) {
            if (result.data.guide_data.length !== 0) {
              window.open(this.url + '/reports/commission_pdf.php?start=' + moment(this.datestart).format('YYYY-MM-DD') + '&end=' + moment(this.dateend).format('YYYY-MM-DD'), '_blank')
              this.hideModalDay()
            } else {
              swal(
                'Alert REPORT Commission!!',
                'NO data sale!!',
                'error'
              )
              this.hideModalDay()
            }
          } else {
            swal(
              'Alert REPORT Commission!!',
              'NO data in report !!',
              'warning'
            )
            this.hideModalDay()
          }
        }, error => {
          alert(JSON.stringify(error))
          this.hideModalMonth()
        })
      }
    },
    excelday () {
      let obj = {
        date_start: this.datestart,
        date_end: this.dateend
      }
      if (this.title === 'รายงานขายประจำวัน') {
        api.AXreportday(this.url, obj, result => {
          if (result.status === 1) {
            if (result.data.length > 0) {
              window.open(this.url + '/reports/sale_excel.php?start=' + moment(this.datestart).format('YYYY-MM-DD') + '&end=' + moment(this.dateend).format('YYYY-MM-DD'), '_blank')
              this.hideModalDay()
            } else {
              swal(
                'Alert REPORT Sale!!',
                'NO data sale!!',
                'error'
              )
            }
          } else {
            swal(
              'Alert REPORT Sale!!',
              'NO data in report!!',
              'warning'
            )
            this.hideModalDay()
          }
        }, error => {
          alert(JSON.stringify(error))
          this.hideModalMonth()
        })
      } else {
        api.AXreportcom(this.url, obj, result => {
          if (result.status === 1) {
            if (result.data.guide_data.length !== 0) {
              window.open(this.url + '/reports/commission_excel.php?start=' + moment(this.datestart).format('YYYY-MM-DD') + '&end=' + moment(this.dateend).format('YYYY-MM-DD'), '_blank')
              this.hideModalDay()
            } else {
              swal(
                'Alert REPORT Commission!!',
                'NO data sale!!',
                'error'
              )
              this.hideModalDay()
            }
          } else {
            swal(
              'Alert REPORT Commission!!',
              'NO data in report!!',
              'warning'
            )
            this.hideModalDay()
          }
        }, error => {
          alert(JSON.stringify(error))
          this.hideModalMonth()
        })
      }
    },
    showModalMonth () {
      this.datemonth = moment(new Date()).format('YYYY-MM')
      $('#month').modal('show')
    },
    hideModalMonth () {
      this.datemonth = moment(new Date()).format('YYYY-MM')
      $('#month').modal('hide')
    },
    salepdfmonth () {
      let obj = {
        date: this.datemonth
      }
      api.AXreportmonth(
        this.url,
        obj,
        result => {
          if (result.status === 1) {
            if (result.data.length > 0) {
              window.open(
                this.url +
                '/reports/sale_month_pdf.php?month=' +
                this.datemonth,
                '_blank'
              )
              this.hideModalMonth()
            } else {
              swal(
                'Alert REPORT Sale Month!!',
                'NO data sale!!',
                'error'
              )
              this.hideModalMonth()
            }
          } else {
            swal(
              'Alert REPORT Sale Month!!',
              'NO data in report!!',
              'warning'
            )
            this.hideModalMonth()
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.hideModalMonth()
        }
      )
    },
    saleexcelmonth () {
      let obj = {
        date: this.datemonth
      }
      api.AXreportmonth(
        this.url,
        obj,
        result => {
          if (result.status === 1) {
            if (result.data.length > 0) {
              window.open(
                this.url +
                '/reports/sale_month_excel.php?month=' +
                this.datemonth,
                '_blank'
              )
              this.hideModalMonth()
            } else {
              swal(
                'Alert REPORT !!',
                'NO data sale!!',
                'error'
              )
              this.hideModalMonth()
            }
          } else {
            swal(
              'Alert REPORT !!',
              'NO data in report!!',
              'warning'
            )
            this.hideModalMonth()
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.hideModalMonth()
        }
      )
    },
    excelEmail () {
      let obj = {
        date_start: this.datestart,
        date_end: this.dateend
      }
      api.exportEmail(this.url, obj, result => {
        if (result.status === 1) {
          if (result.data.length > 0) {
            window.open(this.url + '/reports/email_word.php?start=' + moment(this.datestart).format('YYYY-MM-DD') + '&end=' + moment(this.dateend).format('YYYY-MM-DD'), '_blank')
            this.hideModalDay()
          } else {
            swal(
              'Alert REPORT email!!',
              'NO data email!!',
              'error'
            )
          }
        } else {
          swal(
            'Alert REPORT email!!',
            'NO data in email!!',
            'warning'
          )
          this.hideModalDay()
        }
      }, error => {
        alert(JSON.stringify(error))
        this.hideModalMonth()
      })
    }
  },
  mounted () {
    try {
      this.checkLogin()
    } catch (e) {
      // location.reload()
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/report.js